// static/table_engine_src/core/menu.js

let __menuGlobalRefs = 0;
let __menuPointerHandler = null;
let __menuEscapeHandler = null;

function installMenuGlobals() {
  if (typeof document === "undefined") return () => {};

  if (__menuGlobalRefs === 0) {
    __menuPointerHandler = (e) => {
      const active = document.__teActiveMenuCtx;
      if (!active || !active._menuEl) return;

      if (e.target && e.target.closest && e.target.closest(".te-menu")) return;
      active._menuEl.style.display = "none";
    };

    __menuEscapeHandler = (e) => {
      if (e.key !== "Escape") return;

      const active = document.__teActiveMenuCtx;
      if (!active || !active._menuEl) return;
      if (active._menuEl.style.display !== "block") return;

      e.preventDefault();
      e.stopPropagation();
      active._menuEl.style.display = "none";

      try {
        active.table?.focus({ preventScroll: true });
      } catch {}
    };

    document.addEventListener("pointerdown", __menuPointerHandler, true);
    document.addEventListener("keydown", __menuEscapeHandler, true);
    try {
      document.__teMenuGlobalInstalled = true;
    } catch {}
  }

  __menuGlobalRefs += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;

    __menuGlobalRefs = Math.max(0, __menuGlobalRefs - 1);
    if (__menuGlobalRefs !== 0) return;

    if (__menuPointerHandler) {
      try {
        document.removeEventListener("pointerdown", __menuPointerHandler, true);
      } catch {}
    }
    if (__menuEscapeHandler) {
      try {
        document.removeEventListener("keydown", __menuEscapeHandler, true);
      } catch {}
    }

    __menuPointerHandler = null;
    __menuEscapeHandler = null;

    try {
      delete document.__teMenuGlobalInstalled;
    } catch {
      try {
        document.__teMenuGlobalInstalled = false;
      } catch {}
    }
  };
}

/**
 * Installs:
 *   ctx.ensureMenu() -> HTMLElement
 *   ctx.showMenu(x, y, buildFn)
 *   ctx.hideMenu()
 *   ctx.isMenuOpen() -> boolean
 */
export function installMenu(ctx) {
  if (!ctx) return;

  const addCleanup = typeof ctx.addCleanup === "function" ? ctx.addCleanup : () => {};
  addCleanup(installMenuGlobals());

  function hideMenu() {
    const m = ctx._menuEl;
    if (!m) return;
    m.style.display = "none";
  }

  function destroyMenuEl() {
    const m = ctx._menuEl;
    if (!m) return;

    if (typeof document !== "undefined" && document.__teActiveMenuCtx === ctx) {
      document.__teActiveMenuCtx = null;
    }

    try {
      m.remove();
    } catch {
      try {
        if (m.parentNode) m.parentNode.removeChild(m);
      } catch {}
    }

    ctx._menuEl = null;
  }
  addCleanup(destroyMenuEl);

  function ensureMenu() {
    if (ctx._menuEl) return ctx._menuEl;
    if (typeof document === "undefined") return null;

    const m = document.createElement("div");
    m.className = "te-menu";
    m.style.position = "fixed";
    m.style.zIndex = "9999";
    m.style.minWidth = "210px";
    m.style.background = "#0a1f44";
    m.style.border = "1px solid rgba(255,255,255,0.15)";
    m.style.borderRadius = "10px";
    m.style.boxShadow = "0 8px 22px rgba(0,0,0,0.35)";
    m.style.padding = "6px";
    m.style.display = "none";
    m._build = () => {};

    document.body.appendChild(m);
    ctx._menuEl = m;
    return m;
  }

  function showMenu(x, y, buildFn) {
    const m = ensureMenu();
    if (!m) return;

    document.__teActiveMenuCtx = ctx;

    m._build = buildFn || (() => {});
    try {
      m._build?.();
    } catch {}

    m.style.display = "block";

    const pad = 8;
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    m.style.left = "0px";
    m.style.top = "0px";

    const rect = m.getBoundingClientRect();
    const left = Math.min(vw - rect.width - pad, Math.max(pad, x));
    const top = Math.min(vh - rect.height - pad, Math.max(pad, y));

    m.style.left = `${left}px`;
    m.style.top = `${top}px`;
  }

  function isMenuOpen() {
    const m = ctx._menuEl;
    return !!(m && m.style.display === "block");
  }

  ctx.ensureMenu = ensureMenu;
  ctx.showMenu = showMenu;
  ctx.hideMenu = hideMenu;
  ctx.isMenuOpen = isMenuOpen;
}
